import React, { useState,useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import {Box,Grid,Typography,TextField} from '@mui/material';
import { useAddBulkRoleAssignment } from '../../Hooks';
import FormikControl from '../../../../components/FormikControls/FormikControl';
import { Formik, Form } from 'formik';
import { ReactComponent as AddTeamVector } from '../../StaticData/Vectors/addTeamVector.svg';
import { useGetAllUserRolesByTeamId,useGetAllRolesByTenantId} from '../../Hooks';
import {useGetAllPersonPictureByTenantId} from '../../../AllTenantOkrs/Hooks/index';
import { useSelector } from 'react-redux';
import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
import TeamAndKrDetail, { AccessCart } from "../../Copmonents/AccessCart/AccessCart"
import MultiSelect from '../../../../components/FormikControls/MultiSelect/MultiSelect';
import {useGetTeamDetail } from '../../Hooks';
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';
import Radio from '@mui/material/Radio';
import EditIcon from '@mui/icons-material/Edit';
import PersonIcon from '@mui/icons-material/Groups';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Divider from "@mui/material/Divider";
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';

// setShowToastMessage={setShowToastMessage}
// setAddTeamState={setTeamAsyncOpState}
const AccessLevel = (props:any) => {
    let{loading,onClose,setShowToastMessage,setEditTeamState,teamId}=props;
    // const [teamId,setTeamId]=useState<string|null>(null)
    // const tenantId: any = useSelector((state: any) => state.meetings.profileTenantId);
    // const{data:teamDetailData,isLoading:getTeamDetailLoading,isFetched:getTeamDetailFetched}=useGetTeamDetail(props?.teamId);
    const{mutate:callAddBulkRoleAssignment,data:editTeamData,isSuccess,isError}=useAddBulkRoleAssignment()
    const tenantId: any = useSelector((state: any) => state.meetings.profileTenantId);
    const userId=useSelector((state:any)=>state.loign.userInfo.userId);
    let{data:activePersonData,isLoading:getActivePersonLoading}=useGetAllUserRolesByTeamId(teamId);
    const{data:deletePersonData,isSuccess:deletePerSuccess}=useGetAllRolesByTenantId(tenantId);
    const{data:personPicture}=useGetAllPersonPictureByTenantId(tenantId);
    const[showLToastMessage,setLShowToastMessage]=useState<boolean>(false);


    useEffect(() => {
  
   if (editTeamData) {
    setShowToastMessage(true)
    setEditTeamState(editTeamData?.data)
    onClose(false)
   }
     
    }, [editTeamData,isSuccess])

    // useEffect(() => {
    //     setPersonIdData(activePersonData?.map((item:any)=>{
    //       let{key,value}=item;
    //       return {year:value,title:key}
    
    //     }))
    
    //   }, [activePersonData]);

      useEffect(() => {
        
    if (isError) {
    

      setLShowToastMessage(true);
    }
    // teamAsynOpcState,setTeamAsyncOpState
      }, [isError,editTeamData])
      

    const initialSubmitForm=(activePersonData : any)=>{
    callAddBulkRoleAssignment(activePersonData)
    }

    if (getActivePersonLoading) {
        return <Box py={4} textAlign={'center'}  >
            {/* <CircularProgress  /> */}
            <CircularProgress/>
        </Box>
    }

    return (
            <Grid container>
          <Grid item xs={12}  >
            <Box width={'100%'} textAlign={'center'}   >
            </Box>
          </Grid>
          <Grid item xs={12}   >
      {
       !getActivePersonLoading === true ?  <Formik 
         enableReinitialize
          initialValues={activePersonData}
          onSubmit={() => {
            initialSubmitForm(activePersonData)
          }}
        >
          {
            ({ values, setFieldValue, dirty, isValid, touched, errors, setFieldTouched }) =>
              <Form>
                <Grid container columnSpacing={1} sx={{ bgcolor: 'background.paper', mx: 'auto', borderRadius: 3 }}>
                <Grid item xs={12} md={12}   >
                    {/* <Box width={'100%'} height={'30px'} >
                    <Typography px={1} >
                            در حال ویرایش دسترسی اعضا تیم برای
                       </Typography>
                    </Box>
                    <Box width={'100%'} height={'30px'} >
                    <Typography px={1} fontWeight={700} color={'#00387C'} >
                      اسم تیم
                       </Typography>
                    </Box> */}
                </Grid>
                <Grid item xs={12} md={12}  >
                <Divider variant="fullWidth" />
                    <Box width={'100%'} height={'30px'} >
                    <Typography px={1} >
                        <PersonIcon/> لیست افراد      
                       </Typography>
                    </Box>
                </Grid>
              {
                activePersonData !== null && activePersonData !== undefined ?  
                <Grid container >
                <Grid item xs={12} spacing={1} px={1}>
                {
                  activePersonData && activePersonData.map((o:any,i:number)=>{
                     return <Grid  item xs={12} sm={12}  >
                 <Accordion >
                  <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                  >
                  <Box  mx={0.5} >
                  {
                    <img src={
                      personPicture !== null && personPicture !== undefined &&
                  personPicture.filter((x:any)=>x.personId === o?.personId)[0] !== null &&
                  personPicture.filter((x:any)=>x.personId === o?.personId)[0]!== undefined
                  ?
                  personPicture.filter((x:any)=>x.personId === o?.personId)[0].pictureBase64String
                  :''
                    } width={'23px'} style={{borderRadius:'50%'}} />
                  }
                  </Box>
                  <Typography justifyContent={'right'}> {o?.personName} : </Typography> 
                  <Typography > {o?.roleName}   </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                  <Box  bgcolor={'#E5F1FF'} width={'100%'} height={'45px'}  alignItems={'center'} borderRadius={3} display={'flex'} justifyContent={'center'} >
                  <FormControl>
                  <FormLabel id="demo-radio-buttons-group-label"><Typography></Typography> 
                  </FormLabel>
                      <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="row-radio-buttons-group"
                          defaultValue={o?.roleId}
                      >
                {
                    deletePersonData !== null && deletePersonData !== undefined ? 
                    deletePersonData && deletePersonData.map((z:any,i:number)=>{
                          return <Grid  >
                          <Box  bgcolor={'#E5F1FF'} width={'100%'} height={'10px'}  borderRadius={3} display={'flex'} justifyContent={'space-around'} >
                            <FormControlLabel value={z?.id}  control={<Radio />} label={z?.name} 
                            onChange={({target}:any)=>{
                              let {value}=target;
                              // let x = activePersonData.filter((x:any)=>x.userId === o.userId)[0];
                              activePersonData.filter((x:any)=>x.userId === o.userId)[0].roleId = value;
                            }}
                             />
                            </Box>
                           <Grid item xs={12} md={12}>
                         </Grid> 
                          </Grid>
                        })
                    :
                    <Box></Box>
                }     
                  </RadioGroup>
                  </FormControl>
                  </Box>
                  </AccordionDetails>
                 </Accordion>
                        </Grid>
            })
                }
                </Grid>
                </Grid>:
                <Grid>
                  <Box></Box> 
                </Grid>
              }
              
                <Grid item xs={12} mt={2}  >
                  <Box px={1} columnGap={2} display={'flex'} justifyContent={'center'} flexDirection={'row-reverse'}  >
                    <Box >
                      <DyButton
                        caption={'ایجاد تغییرات'}
                        color={'#00387C'}
                        onClick={() => { }}
                        disbled={!dirty || !isValid || !values?.name} 
                        variant={'contained'}
                        bgColor={'#00387C'}
                        type={'submit'}
                      />
                    </Box>
                    <Box>
                      <DyButton
                        caption={'انصراف'}
                        variant={'outlined'}
                        onClick={()=>{
                          onClose(false)
                        }}
                      />
                    </Box>
                  </Box>
                </Grid>
                </Grid>
              </Form>
          }
            </Formik>:''
      }
          </Grid>
              {/* {
                showLToastMessage && <DYToastMessage
                isSuccess={teamAsynOpcState?.isSuccess}
                message={teamAsynOpcState?.metaData.message}
                setShow={setShowToastMessage}
                show={showLToastMessage}
                />
                }
            */}
            </Grid>
        )
}

export default AccessLevel